const UserCardTestIdsScope = {
  USER_CARD: 'user-card',
};

export const UserCardTestIds = {
  VIEW_LOAN_EDITS_BUTTON: `${UserCardTestIdsScope.USER_CARD}.view-loan-edits-button`,
};
